<template>
  <!-- BEGIN: Content-->
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top profile__avatar">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                {{ title }}
              </h2>
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
               
              @click="$router.push({name: 'researcher.industrial-property.create'})"
            ><i data-feather="plus" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="properties"
              :sort-mapping="sortMapping"
              :title="'industrial properties'"
              :total="propertiesTotal"
              :fetch-path="'tecnologyTransfers/fetchIndustrialProperty'"
              :filter-path="'tecnologyTransfers/filterIndustrialProperty'"
              :export-path="'tecnologyTransfers/exportIndustrialProperty'"
            >
              <!-- :export-path="'tecnologyTransfers/exportIndustrialProperty'" -->
              <template v-slot="{field, showInfoSheet}">
                <td
                  class="text-end"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="p-0"
                    right
                  >
                    <template #button-content>
                      <i data-feather="more-vertical" />
                    </template>
                    <div
                      class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                    >
                      <b-dropdown-item @click="$router.push({name: 'researcher.dashboard', params: { id: field.user.id }})">
                        <i
                          class="me-50"
                          data-feather="user"
                        /> View researcher profile
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item @click="showInfoSheet(field)">
                        <i
                          class="me-50"
                          data-feather="eye"
                        /> View industrial property
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="loggedUser.roles.includes('super-admin') || loggedUser.id === field.user.id"
                        @click="$router.push({name: 'researcher.industrial-property.edit', params: { id: field.id }})"
                      >
                        <i
                          class="me-50"
                          data-feather="edit-3"
                        /> Edit
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="loggedUser.roles.includes('super-admin') || loggedUser.id === field.user.id"
                        :href="$router.resolve({name: 'researcher.industrial-property.edit', params: { id: field.id }}).href"
                        target="_blank"
                      >
                        <i data-feather="external-link" />
                        Edit in new tab
                      </b-dropdown-item>
                      <b-dropdown-item @click="showDeleteModal(field.id)">
                        <i
                          class="me-50"
                          data-feather="trash-2"
                        /> Delete <span class="float-end"><i data-feather="lock" /></span>
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                  <a
                    href=""
                    class="btn btn-icon btn-light-secondary d-block d-sm-none"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMenu"
                    aria-controls="offcanvasBottom"
                  ><i
                    data-feather="more-vertical"
                  /></a>
                </td>
              </template>
              <template #customfilters>
                <div
                  v-if="loggedUser.roles.includes('super-admin')"
                  class="mb-1"
                >
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Researcher</label>
                  <v-select
                    label="name"
                    :options="users"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
                    @input="saveFilter($event, 'researcher')"
                  />
                  <hr>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Title</label>
                  <input
                    type="text"
                    class="form-control"
                    @change="saveFilter($event.target.value, 'title')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Patent number</label>
                  <input
                    type="text"
                    class="form-control"
                    @change="saveFilter($event.target.value, 'patent_number')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Status</label>
                  <v-select
                    label="status"
                    :options="statuses"
                    :get-option-key="option => option.id"
                    @input="saveFilter($event, 'status')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Host</label>
                  <v-select
                    label="name"
                    :options="hosts"
                    :get-option-key="option => option.id"
                    @input="saveFilter($event, 'host')"
                    @search="onSearch({ name: $event }, 'institutions/filter')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Type</label>
                  <v-select
                    label="name"
                    :options="types"
                    :get-option-key="option => option.id"
                    @input="saveFilter($event, 'type')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Filing date (From year)</label>
                  <date-picker
                    v-model="filters['filing_date_from']"
                    format="Y"
                    type="year"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'filing_date_from')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Filing date (To year)</label>
                  <date-picker
                    v-model="filters['filing_date_to']"
                    format="Y"
                    type="year"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'filing_date_to')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Contract date (From year)</label>
                  <date-picker
                    v-model="filters['contract_date_from']"
                    format="Y"
                    type="year"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'contract_date_from')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Contract date (To year)</label>
                  <date-picker
                    v-model="filters['contract_date_to']"
                    format="Y"
                    type="year"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'contract_date_to')"
                  />
                </div>

                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Active</label>
                  <select
                    id=""
                    name=""
                    class="form-select"
                    @input="saveFilter($event.target.value, 'active')"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="true">
                      Yes
                    </option>
                    <option value="false">
                      No
                    </option>
                  </select>
                </div>
              </template>
              <template #info-sheet-item="{item}">
                <div class="offcanvas-body offcanvas-body--view">
                  <div class="mb-1 offcanvas-body--view--title">
                    <p>Researcher<br>
                      <strong>{{ item.user.first_name }} {{ item.user.last_name }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1 offcanvas-body--view--title">
                    <p>Title<br>
                      <strong>{{ item.title }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Host<br>
                      <strong>{{ item.current_host }}</strong></p>
                  </div>
                  <div class="mb-1">
                    <p>Patent number<br>
                      <strong>{{ item.patent_application_number }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Status<br>
                      <strong>{{ item.status ? item.status.status : '-' }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Type<br>
                      <strong>{{ item.type ? item.type.name : '-' }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Active<br>
                      <strong
                        v-if="!item.publish"
                        class="badge badge-light-danger"
                      >No</strong>
                      <strong
                        v-if="item.publish"
                        class="badge badge-light-success"
                      >Yes</strong>
                    </p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Filing date<br>
                      <strong>{{ item.filing_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Contract date<br>
                      <strong>{{ item.contract_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Comunication date to icrea<br>
                      <strong>{{ item.communication_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Licensed date<br>
                      <strong>{{ item.licensed_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Sold date<br>
                      <strong>{{ item.sold_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Abandoned date<br>
                      <strong>{{ item.abandoned_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Publication date<br>
                      <strong>{{ item.publication_date }}</strong></p>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <p>Inventors</p>
                    <ul>
                      <li
                        v-for="inventor in item.inventors"
                        :key="inventor.id"
                      >
                        <template v-if="inventor.user_id">
                          <a
                            v-if="loggedUser.roles.includes('super-admin')"
                            :href="$router.resolve({name: 'researcher.dashboard', params: { id: inventor.user_id }}).href"
                            target="_blank"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="view profile"
                          >
                            {{ inventor.name }} {{ inventor.host_code ? `- (${inventor.host_code})` : '' }}
                          </a>
                          <a
                            v-else
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="view profile"
                          >
                            {{ inventor.name }} {{ inventor.host_code ? `- (${inventor.host_code})` : '' }}
                          </a>
                          <span class="badge bg-light-secondary">ICREA</span>
                        </template>
                        <template v-else>
                          {{ inventor.name }} {{ inventor.host_code ? `- (${inventor.host_code})` : '' }}
                        </template>
                      </li>
                    </ul>
                  </div>
                  <hr>
                  <div class="mb-1">
                    <h4>Abstract / Summary</h4>
                    <p v-html="item.summary" />
                  </div>
                  <hr>
                  <div class="mb-1">
                    <h4>Documents</h4>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>File name</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="file in item.files"
                          :key="file.id"
                        >
                          <td>{{ file.name }}</td>
                          <td class="text-end">
                            <a
                              :href="file.url"
                              target="_blank"
                            ><i data-feather="download" /></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="offcanvas-footer mt-auto">
                  <a
                    v-if="loggedUser.roles.includes('super-admin') || loggedUser.id === item.user.id"
                    title="edit this industrial property"
                    class="btn btn-primary mb-1 d-grid w-100"
                    @click="$router.push({name: 'researcher.industrial-property.edit', params: { id: item.id }})"
                  >Edit</a>
                </div>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import CompleteTable from '../../partials/components/CompleteTable.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    vSelect,
    DatePicker,
  },
  data() {
    return {
      filters: [],
      sortedField: 'Researcher',
      defaultFields: [
        {
          name: 'Researcher',
          checked: true,
          order: 1,
          only_admin: true,
        },
        {
          name: 'Host',
          checked: true,
          order: 2,
        },
        {
          name: 'Type',
          checked: true,
          order: 3,
        },
        {
          name: 'Filing date',
          checked: true,
          order: 4,
        },
        {
          name: 'Title',
          checked: true,
          order: 5,
        },
        {
          name: 'Patent number',
          checked: true,
          order: 6,
        },
        {
          name: 'Contract date',
          checked: false,
          order: 7,
        },
        {
          name: 'Licensed date',
          checked: false,
          order: 8,
        },
        {
          name: 'Sold date',
          checked: false,
          order: 9,
        },
        {
          name: 'Abandoned date',
          checked: false,
          order: 10,
        },
        {
          name: 'Publication date',
          checked: false,
          order: 11,
        },
        {
          name: 'Status',
          checked: true,
          order: 12,
        },
        {
          name: 'Published',
          checked: true,
          order: 13,
        },
      ],
      sortMapping: {
        Researcher: 'user.name',
        Title: 'title',
        Host: 'current_host',
        'Patent number': 'patent_application_number',
        'Filing date': 'filing_date',
        'Contract date': 'contract_date',
        'Licensed date': 'licensed_date',
        'Sold date': 'sold_date',
        'Abandoned date': 'abandoned_date',
        'Publication date': 'publication_date',
        Status: 'status.status_table',
        Type: 'type.name',
        Published: 'publish',
      },
      title: 'Industrial property',
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      properties: 'tecnologyTransfers/industrialProperties',
      propertiesTotal: 'tecnologyTransfers/industrialPropertiesTotal',
      users: 'users/fakeUsers',
      statuses: 'status/statuses',
      loggedUser: 'auth/admin',
      filtersTotal: 'filters/filters',
      types: 'industrialPropertyParentTypes/items',
      hosts: 'institutions/institutions',
    }),
  },
  async mounted() {
    await this.$store.dispatch('modals/fetchUserFields', 'industrial-property')
    if (this.$route.query.user_id) {
      await this.saveFilter({ id: this.$route.query.user_id }, 'researcher')
    }
    await this.$store.dispatch('tecnologyTransfers/filterIndustrialProperty', this.filtersTotal)
    await this.$store.dispatch('industrialPropertyParentTypes/filter', this.$store.getters['filters/filters'])
    this.$store.dispatch('status/filterStatus', 'Patent')
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'industrial-property',
      })
    }
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    saveFilter(value, field) {
      this.$store.dispatch('filters/saveFilters', {
        value,
        field,
      })
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
    async showDeleteModal(id) {
      await this.$store.dispatch('modals/saveDeleteData', { name: 'tecnologyTransfers/fetchIndustrialProperties', url: `${Vue.prototype.$groupUrl}/tecnology-transfers/industrial-properties/${id}` })
      this.$store.dispatch('modals/showDeleteModal', true)
    },
  },
}
</script>
